import Alert from "../../../Common/Alert";
import API from "../../../Common/Network/API";
import { isLoaded, isLoading, adminGroups } from "../action";

// for getting group deatils created by admin
export async function getAdminGroup(dispatch, getUser) {
    dispatch(isLoading());
    try {
      var response = await API.post("group_chat.php", {
        action :'getAdminGroup',
        created_by: getUser.userName,
        projectId: getUser.projectId,
        // "userType": getUser.role,
        // "empId": getUser.empId,
      }, {}, false);
      if (response.status === 'True') {
        dispatch(adminGroups(response.data))
      }
      else {
        dispatch(adminGroups([]))
      }
    } catch (error) {
      Alert('error', error.message);
    }
    dispatch(isLoaded());
  }